var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.47944C0 0.846813 0.529625 0.333313 1.1825 0.333313H14.8175C15.4706 0.333313 16 0.846813 16 1.47944V15.1874C16 15.8202 15.4706 16.3333 14.8175 16.3333H1.1825C0.529688 16.3333 0 15.8203 0 15.1876V1.47925V1.47944Z",
    fill: "#006699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86216 13.7233V6.52004H2.46791V13.7233H4.86241H4.86216ZM3.66553 5.53673C4.50028 5.53673 5.01997 4.98361 5.01997 4.29236C5.00434 3.58536 4.50028 3.04767 3.68141 3.04767C2.86197 3.04767 2.32678 3.58536 2.32678 4.29229C2.32678 4.98354 2.84628 5.53667 3.64984 5.53667H3.66534L3.66553 5.53673ZM6.18741 13.7233H8.58147V9.70111C8.58147 9.48611 8.5971 9.27054 8.66035 9.11698C8.83334 8.68667 9.22728 8.24123 9.88885 8.24123C10.755 8.24123 11.1017 8.90173 11.1017 9.87017V13.7233H13.4957V9.59317C13.4957 7.38073 12.3147 6.35117 10.7395 6.35117C9.44803 6.35117 8.88084 7.07298 8.56572 7.56461H8.58166V6.52029H6.18753C6.21878 7.19604 6.18734 13.7235 6.18734 13.7235L6.18741 13.7233Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f48deaa2595d3b368afe09fed9ab0cf7.svg";
export { ForwardRef as ReactComponent };